<template>
  <div :class="classList">
    <slot name="gridItem" />
  </div>
</template>

<script>
import addSlotClasses from '../mixins/slotClassAddition';

export default {
  mixins: [addSlotClasses],
  name: 'v-grid',
  props: {
    gutter: {
      type: [Boolean],
      default: true,
    },
  },
  data() {
    return {
      gridItemClass: 'o-grid__item',
    };
  },
  updated() {
    this.addSlotClasses();
  },
  mounted() {
    this.addSlotClasses();
  },
  computed: {
    classList() {
      const defaultClass = 'o-grid';
      const gutter = !this.gutter ? ' o-grid--no-gutter' : '';
      return defaultClass + gutter;
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../styles/component-utils';

  $parent: '.o-grid';

  #{$parent} {
    margin: 0 -1.5%;
    padding-right: 1.5%;
    position: relative;
    @include clearfix;
    &__item {
      float: left;
      // display: inline-block;
      padding: 0 1.5%;
      padding-right: 0;
      @include createGrid(12);
    }
    &--no-gutter {
      margin: 0;
      padding-right: initial;
      > #{$parent}__item {
        padding: 0;
      }
    }
  }

  // responsive
  @media screen and (max-width: $screen-size-large) {
    #{$parent}:not(#{$parent}--no-collapse-large) {
      &__item {
        width: 100%;
      }
    }
  }
  @media screen and (max-width: $screen-size-xs) {
    #{$parent} {
      &__item {
        width: 100%;
      }
    }
  }

  @supports (display: grid) {
    #{$parent} {
      margin: initial;
      padding-right: initial;
      position: relative;
      display: grid;
      grid-column-gap: $spacing-base;
      grid-row-gap: $spacing-base;
      grid-template-columns: repeat(12, 1fr);
      &__item {
        float: none;
        padding: 0;
        margin: 0;
      }
      &--no-gutter {
        grid-column-gap: 0;
        grid-row-gap: 0;
      }
    }

    // responsive
    @media screen and (max-width: $screen-size-large) {
      #{$parent}:not(#{$parent}--no-collapse-large) {
        grid-template-columns: 1fr !important;
      }
    }
    @media screen and (max-width: $screen-size-xs) {
      #{$parent} {
        grid-template-columns: 1fr !important;
      }
    }
  }
</style>
